import React from "react";
import "../App.css";

export const Home = () => {
  document.title = "Lishal Bhari | Home";
  return (
    <div className="lis-container">
      <div className="lis-imgcontainer">
        <img
          src="./Images/lishal.png"
          alt="Lishal Bhari"
          height={350}
          width={280}
        />
      </div>
      <h1>Lishal Bhari</h1>
      <p>
        I am a Web Developer from
        <a
          className="lis-link_a"
          href="https://www.planetware.com/tourist-attractions/nepal-nep.htm"
          target="__blank"
        >
          Nepal
        </a>
      </p>
    </div>
  );
};
